import {
  axiosGet,
  axiosPost
} from '../api/api'
import {BASE_V_API,BASE_GLOB_API,BASE_RANKING_API} from "@/config.js"
import axios from "axios";
export default {
  //CFX RATE FUNCTION
  getCfxRate(params) {
    return axiosGet(BASE_GLOB_API + `/kanban/cfx/rate`, params)
  },
  getBtyRate(params) {
    return axiosGet(BASE_GLOB_API + `/kanban/bty/rate`, params)
  },
  // Ranking API functions
  rankingBoard(params) {
    return axiosGet(BASE_RANKING_API + `/token/getListings`, params, false)
  },
  vote(params) {
    return axiosPost(BASE_RANKING_API + `/token/vote`, params, false)
  },
  register(params) {
    return axiosPost(BASE_RANKING_API + `/user/register`, params, false)
  },
  getVotingUser(params) {
    return axiosGet(BASE_RANKING_API + `/user`, params, false)
  },

  // File operations
  download(params) {
    return axiosPost(BASE_V_API + `/file/download`, params)
  },
  uptoipfs(params) {
    return axiosPost(BASE_V_API + `/file/up-to-ipfs`, params)
  },
  uploadImg(params) {
    return axiosPost(BASE_V_API +'/file/up-to-ipfs', params)
  },

  // NFT/CFX Core Operations
  addnft(params) {
    return axiosPost(BASE_V_API + `/nft/add`, params)
  },

  searchnft(params) {
    return axiosPost(BASE_V_API + `/nft/my_nft`, params)
  },

  myNft(params) {
    return axiosPost(BASE_V_API +'/nft/my_nft', params)
  },

  // Balance operations
  balance(params) {
    return axiosPost(BASE_V_API + `/nft/balance`, params)
  },

  getBalance(params) {
    return axiosPost(BASE_V_API + `/nft/sys-balance`, params)
  },

  // NFT/CFX Info operations
  getNftInfo(params) {
    return axiosPost(BASE_V_API + `/nft/info`, params)
  },

  getInfo(params) {
    return axiosPost(BASE_V_API + `/nft/game/info`, params)
  },

  // Collection operations
  addMyCollect(params) {
    return axiosPost(BASE_V_API + `/nft/add-my-collect`, params)
  },

  delMyCollect(params) {
    return axiosPost(BASE_V_API + `/nft/del-my-collect`, params)
  },

  myCollect(params) {
    return axiosPost(BASE_V_API + `/nft/my-collect`, params)
  },

  // Market operations
  afterSell(params) {
    return axiosPost(BASE_V_API + `/nft/after-sell`, params)
  },

  marketBuy(params) {
    return axiosPost(BASE_V_API +'/nft/market/buy', params)
  },

  offSell(params) {
    return axiosPost(BASE_V_API +'/nft/market/off-sell', params)
  },
  offSellCFX(params) { //added 2/2 todo 到这了
    return axiosPost(BASE_V_API + `/cfx/market/off-sell`, params)
  },

  getSell(params) {
    return axiosPost(BASE_V_API +'/nft/market/sell', params)
  },

  // Game operations
  startGame(params) {
    return axiosPost(BASE_V_API +'/nft/game/start', params)
  },

  getVote(params) {
    return axiosPost(BASE_V_API +'/nft/game/vote', params)
  },

  getGameEnd(params) {
    return axiosPost(BASE_V_API +'/nft/game/end', params)
  },

  // Other paired operations
  getNftPending(params) {
    return axiosPost(BASE_V_API + `/nft/pending`, params)
  },

  getUrl(params) {
    return axiosPost(BASE_V_API + `/nft/get-url`, params)
  },

  players(params) {
    return axiosPost(BASE_V_API + `/nft/players`, params)
  },

  historyOfParticipation(params) {
    return axiosPost(BASE_V_API + `/nft/game/record`, params)
  },

  checkJoin(params) {
    return axiosPost(BASE_V_API + `/nft/check-join`, params)
  },

  joinRecord(params) {
    return axiosPost(BASE_V_API + `/nft/join-record`, params)
  },

  getTaskDetail(params) {
    return axiosPost(BASE_V_API + `/nft/task_detail`, params)
  },

  getRecent(params) {
    return axiosPost(BASE_V_API + `/nft/recent`, params)
  },

  address_info(params) {
    return axiosPost(BASE_V_API + `/nft/address_info`, params)
  },

  voteRank(params) {
    return axiosPost(BASE_V_API + `/nft/votes_rank`, params)
  },

  getVoteRank(params) {
    return axiosPost(BASE_V_API + `/nft/get_votes_rank`, params)
  },

  getOpting(params) {
    return axiosPost(BASE_V_API + `/nft/game/list`, params)
  },

  getMint(params) {
    return axiosPost(BASE_V_API +'/nft/mint', params)
  },

  postDelete(params) {
    return axiosPost(BASE_V_API +'/nft/delete', params)
  },

  postDestory(params) {
    return axiosPost(BASE_V_API +'/nft/destory', params)
  },

  // Non-paired functions
  serial(params) {
    return axiosPost(BASE_GLOB_API + `/serial/page`, params)
  },
  saleBalance(params) {
    return axiosPost(BASE_V_API + `/sale/balance`, params)
  },
  saleBase(params) {
    return axiosPost(BASE_V_API + `/sale/base`, params)
  },
  distribution(params) {
    return axiosPost(BASE_V_API + `/sale/distribution`, params)
  },
  pieChart(params) {
    return axiosPost(BASE_V_API + `/sale/pie-chart`, params)
  },
  status(params) {
    return axiosPost(BASE_V_API + `/sale/status`, params)
  },
  active(params) {
    return axiosPost(BASE_V_API + `/sale/tx-list`, params)
  },
  get_user(params) {
    return axiosPost(BASE_V_API + `/get_user`, params)
  },
  metamask_login(params) {
    return axiosPost(BASE_V_API + `/metamask_login`, params)
  },
  getMarket(params) {
      return axiosPost(BASE_V_API + `/nft/market`, params)
  },
  axiosGetInfo(params) {
    return axiosGet(BASE_V_API +'/user/info', params)
  }
}

